declare namespace arjoJs {
  function isDesktop(): boolean;
}

(() => {
  const header = {
    init: function () {
      this.setPositionHeaderMenu();
      this.setPositionHeaderMenuResize();
      this.addEventToHamburger();
      this.showSubmenuMobile();
      this.backToPreviousMenu();
      this.initDropdown();
      this.initMiniSearch();
      this.initDropdownMobile();
      this.addStoreEvent();
      this.initSearchBarMenu();

      setTimeout(() => {
        this.initAnchorPosition();
      });
    },

    /**
     * set position for header menu
     *
     * @returns void
     */
    setPositionHeaderMenu: function () {
      const mainMenu = document.querySelector<HTMLElement>('.arjo-o-eshop-header-main-menu');

      if (!mainMenu) {
        return;
      }

      let header = document.querySelector<HTMLElement>('.arjo-o-eshop-header');
      if (header) {
        document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
      }

      let breadcrumb = document.querySelector<HTMLElement>('.arjo-m-breadcrumb');
      if (breadcrumb) {
        document.body.style.setProperty('--breadcrumb-height', `${breadcrumb.offsetHeight}px`);
      }
    },
    setPositionHeaderMenuResize: function () {
      window.addEventListener('resize', this.setPositionHeaderMenu);
    },

    /**
     * process hamburger click to show header main menu
     *
     * @returns void
     */
    addEventToHamburger: function () {
      const hamburgers = document.querySelectorAll('.js-arjo-o-eshop-hamburger');

      if (!hamburgers.length) {
        return;
      }

      for (const hamburger of hamburgers) {
        hamburger.addEventListener('click', this.handleHamburgerClick.bind(this));
      }
    },

    /**
     * Funciton close main menu
     */
    closeMainMenu: function () {
      const header = document.querySelector<HTMLElement>('.arjo-o-eshop-header');
      const humburgers = document.querySelectorAll<HTMLElement>('.js-arjo-o-eshop-hamburger');

      if (!header) {
        return;
      }

      header.classList.remove('active');
      document.body.style.overflow = '';
      header?.classList.remove('is-move');
      document.querySelector('.arjo-o-eshop-cross-portal-menu__avatar')?.classList.remove('is-show');
      document.querySelector('.arjo-o-eshop-cross-portal-menu__left')?.classList.remove('is-show');
      humburgers.length &&
        [].forEach.call(humburgers, (humburger: HTMLElement) => humburger.querySelector('.arjo-a-hamburger')?.classList.remove('active'));

      this.closeAllChildMenu();
    },

    /**
     * Function open main menu
     */
    openMainMenu: function () {
      const header = document.querySelector<HTMLElement>('.arjo-o-eshop-header');
      const humburgers = document.querySelectorAll<HTMLElement>('.js-arjo-o-eshop-hamburger');

      if (!header) {
        return;
      }

      header.classList.add('active');
      humburgers.length &&
        [].forEach.call(humburgers, (humburger: HTMLElement) => humburger.querySelector('.arjo-a-hamburger')?.classList.add('active'));
      document.body.style.overflow = 'hidden';

      // close all child menu before open
      this.closeAllChildMenu();

      // set scrollable
      const mainMenu = document.querySelector<HTMLElement>('.arjo-o-eshop-header-main-menu');
      const posElem = document.querySelector<HTMLElement>('.arjo-o-eshop-header-main-menu__position');
      const headerBottom = document.querySelector<HTMLElement>('.arjo-o-eshop-header-bottom');
      const headerSecondary = document.querySelector<HTMLElement>('.arjo-o-eshop-header-secondary');

      posElem && posElem!.classList.add('scrollable');
      mainMenu!.style.setProperty('--scrollY', `${window.scrollY}px`);
      mainMenu!.style.setProperty(
        '--max-height',
        `calc(var(--viewport-height) - ${(headerBottom ? headerBottom.offsetHeight : 0) + (headerSecondary ? headerSecondary.offsetHeight : 0)}px)`
      );
    },

    /**
     * This funciton process for child menu
     */
    closeAllChildMenu: function () {
      const header = document.querySelector<HTMLElement>('.arjo-o-eshop-header');

      if (!header) {
        return;
      }

      let showElems = header.querySelectorAll('.has-children.is-show');

      if (showElems.length) {
        for (const showElem of showElems) {
          showElem.classList.remove('is-show');
        }
      }

      header.querySelector('.arjo-o-eshop-header-main-menu__child-items.scrollable')?.classList.remove('scrollable');
      header?.style.setProperty('--unit', '');
    },

    /**
     * process hamburger click to show header main menu
     *
     * @returns void
     */
    handleHamburgerClick: function (event: Event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const header = document.querySelector<HTMLElement>('.arjo-o-eshop-header');
      const bottomElem = document.querySelector<HTMLElement>('.arjo-o-eshop-header-bottom');

      if (!header) {
        return;
      }

      header.style.setProperty('--height-mobile', `${bottomElem?.clientHeight}px`);

      if (header.classList.contains('active')) {
        this.closeMainMenu();
      } else {
        this.openMainMenu();
        this.bannerFunctions.hideBanner();
      }
    },
    /**
     * Show submenu items when click to arrow icon
     */
    showSubmenuMobile: function () {
      const arrows = document.querySelectorAll('.arjo-o-eshop-header-main-menu__arrow');

      if (!arrows.length) {
        return;
      }

      for (const arrow of arrows) {
        arrow.addEventListener('click', this.handleClickArrow);
      }
    },
    handleClickArrow: function (event: Event) {
      event.preventDefault();

      const header = document.querySelector<HTMLElement>('.arjo-o-eshop-header');
      const currentUnit = parseInt(header?.style.getPropertyValue('--unit') as string);

      header?.classList.add('is-move');
      (event.target as HTMLElement)!.closest('.arjo-o-eshop-header-main-menu__child-items')?.classList.remove('scrollable');
      (event.target as HTMLElement)!.nextElementSibling?.classList.add('scrollable');
      (event.target as HTMLElement)!.closest('.has-children')?.classList.add('is-show');
      header?.style.setProperty('--unit', `${currentUnit ? currentUnit + 1 : 1}`);
    },
    backToPreviousMenu: function () {
      let backElems = document.querySelectorAll('.js-arjo-o-eshop-back');

      if (!backElems.length) {
        return;
      }

      for (const baclElem of backElems) {
        baclElem.addEventListener('click', this.handleBackPreviousMenu);
      }
    },
    handleBackPreviousMenu: function (event: Event) {
      event.preventDefault();

      const header = document.querySelector<HTMLElement>('.arjo-o-eshop-header');
      const currentUnit = parseInt(header?.style.getPropertyValue('--unit') as string);

      if (currentUnit <= 1) {
        header?.classList.remove('is-move');
      }

      header?.style.setProperty('--unit', `${currentUnit && currentUnit > 1 ? currentUnit - 1 : ''}`);
      (event.target as HTMLElement)!.closest('.arjo-o-eshop-header-main-menu__child-items')?.classList.remove('scrollable');
      (event.target as HTMLElement)!.closest('.has-children')?.classList.remove('is-show');
      currentUnit <= 1 && header?.classList.remove('is-move');
    },
    bannerFunctions: {
      customerBanner: document.querySelector<HTMLElement>('.arjo-o-user-profile-banner--customer-show'),
      localBanner: document.querySelector<HTMLElement>('.arjo-o-user-profile-banner--local-show'),
      navLinkCustomer: document.querySelector<HTMLElement>('.js-arjo-o-eshop-header-login'),
      navLinkRegion: document.querySelector<HTMLElement>('.js-arjo-o-eshop-header-region'),
      setCustomerOverflowVisible: function () {
        const customerBanner = document.querySelector<HTMLElement>('.arjo-o-user-profile-banner--customer-show');
        customerBanner!.style.overflow = 'visible';
      },
      setCustomerOverflowHidden: function () {
        const customerBanner = document.querySelector<HTMLElement>('.arjo-o-user-profile-banner--customer-show');
        customerBanner!.style.overflow = 'hidden';
      },
      setLocalOverflowVisible: function () {
        const localBanner = document.querySelector<HTMLElement>('.arjo-o-user-profile-banner--local-show');
        localBanner!.style.overflow = 'visible';
      },
      setLocalOverflowHidden: function () {
        const localBanner = document.querySelector<HTMLElement>('.arjo-o-user-profile-banner--local-show');
        localBanner!.style.overflow = 'hidden';
      },
      clearBannerListener: function () {
        this.customerBanner && this.customerBanner!.removeEventListener('transitionstart', this.setCustomerOverflowHidden);
        this.customerBanner && this.customerBanner!.removeEventListener('transitionend', this.setCustomerOverflowVisible);
        this.localBanner && this.localBanner!.removeEventListener('transitionstart', this.setLocalOverflowHidden);
        this.localBanner && this.localBanner!.removeEventListener('transitionend', this.setLocalOverflowVisible);
      },
      hideBanner: function () {
        const businessBanner = document.querySelectorAll<HTMLElement>('.arjo-o-user-profile-banner');
        if (!businessBanner) {
          return;
        }
        this.clearBannerListener();
        this.navLinkCustomer?.classList.remove('active');
        this.navLinkRegion?.classList.remove('active');

        [].forEach.call(businessBanner, (banner: HTMLElement) => {
          if (!banner!.classList.contains('hide')) {
            banner!.classList.add('hide');
            banner!.style.overflow = 'hidden';
          }
        });

        const miniSearch = document.querySelector('.arjo-o-eshop-header-mini-search');
        const searchBtn = document.querySelector('.ajro-o-searchbar__search-btn');
        if (!miniSearch || !searchBtn) {
          return;
        }
        if (!miniSearch.classList.contains('hide')) {
          miniSearch.classList.add('hide');
          searchBtn.classList.remove('active');
        }
      },
    },
    initDropdown: function () {
      if (!arjoJs.isDesktop()) {
        return;
      }

      const customerBanner = document.querySelector<HTMLElement>('.arjo-o-user-profile-banner--customer-show');

      if (!customerBanner) {
        return;
      }

      const localBanner = document.querySelector<HTMLElement>('.arjo-o-user-profile-banner--local-show');
      const customerCloseBtn = customerBanner!.querySelector('.arjo-o-user-profile-banner__close-button');
      const localCloseBtn = localBanner!.querySelector('.arjo-o-user-profile-banner__close-button');
      const customerForm = document.getElementById('customer-form') as HTMLFormElement;
      const localForm = document.getElementById('local-form') as HTMLFormElement;
      const fn = this.bannerFunctions;

      // Code logic show/hide banner
      fn.navLinkCustomer!.addEventListener('click', showCustomerBanner);
      fn.navLinkRegion!.addEventListener('click', showLocalBanner);
      customerCloseBtn!.addEventListener('click', fn.hideBanner.bind(fn));
      localCloseBtn!.addEventListener('click', fn.hideBanner.bind(fn));

      function showCustomerBanner(e: Event) {
        e.preventDefault();
        if (!customerBanner) {
          return;
        }
        fn.clearBannerListener();
        if (customerBanner.classList.contains('hide')) {
          fn.hideBanner();
          header.closeMainMenu();
          customerBanner.addEventListener('transitionend', fn.setCustomerOverflowVisible);
          customerBanner.classList.remove('hide');
          fn.navLinkCustomer?.classList.add('active');
        } else {
          customerBanner.addEventListener('transitionstart', fn.setCustomerOverflowHidden);
          customerBanner.classList.add('hide');
          fn.navLinkCustomer?.classList.remove('active');
        }
      }
      function showLocalBanner(e: Event) {
        e.preventDefault();
        if (!localBanner) {
          return;
        }
        fn.clearBannerListener();
        if (localBanner.classList.contains('hide')) {
          fn.hideBanner();
          header.closeMainMenu();
          localBanner.addEventListener('transitionend', fn.setLocalOverflowVisible);
          localBanner.classList.remove('hide');
          fn.navLinkRegion?.classList.add('active');
        } else {
          localBanner.addEventListener('transitionstart', fn.setLocalOverflowHidden);
          localBanner.classList.add('hide');
          fn.navLinkRegion?.classList.remove('active');
        }
      }

      // logic on change dropdown

      const customerDropdown = customerBanner!.querySelector('.arjo-m-dropdown');
      if (customerDropdown) {
        customerDropdown.addEventListener('dropdownChange', (e) => {
          // @ts-ignore
          customerForm.submit();
        });
      }

      const localDropdown = localBanner!.querySelector('.arjo-m-dropdown');
      if (localDropdown) {
        let inputSite = localForm.querySelector<HTMLInputElement>('input[name=site]');
        let inputPage = localForm.querySelector<HTMLInputElement>('input[name=currentPageId]');
        let inputCurrentPage = document.querySelector<HTMLInputElement>('input#currentPageId');
        localDropdown.addEventListener('dropdownChange', (e) => {
          if (inputSite) {
            // @ts-ignore
            inputSite.value = e.detail.value;
          }
          if (inputPage && inputCurrentPage) {
            inputPage.value = inputCurrentPage.value;
          }
          localForm.submit();
        });
      }
    },
    initMiniSearch: function () {
      const miniSearch = document.querySelector('.arjo-o-eshop-header-mini-search');
      const searchBtn = document.querySelector('.ajro-o-searchbar__search-btn');

      searchBtn?.addEventListener('click', showMiniSearch);

      function showMiniSearch() {
        if (!miniSearch || !searchBtn) {
          return;
        }
        if (miniSearch.classList.contains('hide')) {
          miniSearch.classList.remove('hide');
          searchBtn.classList.add('active');
        } else {
          miniSearch.classList.add('hide');
          searchBtn.classList.remove('active');
        }
      }
    },
    initDropdownMobile: function () {
      if (arjoJs.isDesktop()) {
        return;
      }
      const navLinkCustomer = document.querySelector<HTMLElement>('.js-arjo-o-eshop-header-login');

      if (!navLinkCustomer) {
        return;
      }

      const customerDropdown = document.querySelector<HTMLElement>('.arjo-o-eshop-header-secondary__customer-dropdown');
      const navLinkLocal = document.querySelector<HTMLElement>('.js-arjo-o-eshop-header-region');
      const localDropdown = document.querySelector<HTMLElement>('.arjo-o-eshop-header-secondary__local-dropdown');

      navLinkCustomer?.addEventListener('click', showCustomerDropdown);
      navLinkLocal?.addEventListener('click', showLocalDropdown);

      function showCustomerDropdown() {
        if (!customerDropdown) {
          return;
        }
        customerDropdown.classList.toggle('hide');
        navLinkCustomer?.classList.toggle('is-show');
      }

      const customerForm = customerDropdown?.querySelector<HTMLFormElement>('#customer-mb-form');

      if (customerDropdown) {
        const options = customerDropdown.querySelectorAll('.arjo-m-dropdown__options-input');
        [].forEach.call(options, (option: HTMLOptionElement) => {
          option.addEventListener('change', () => {
            customerForm?.submit();
          });
        });
      }
      function showLocalDropdown() {
        if (!localDropdown) {
          return;
        }
        localDropdown.classList.toggle('hide');
        navLinkLocal?.classList.toggle('is-show');
      }

      const localForm = localDropdown?.querySelector<HTMLFormElement>('#local-mb-form');
      let inputCurrentPage = document.querySelector<HTMLInputElement>('input#currentPageId');

      if (localDropdown) {
        const options = localDropdown.querySelectorAll('.arjo-m-dropdown__options-input');
        [].forEach.call(options, (option: HTMLOptionElement) => {
          option.addEventListener('change', () => changeEventHandler(option));
        });
      }

      function changeEventHandler(inputElement: any) {
        if (!inputElement.checked) {
          return;
        }
        if (!localForm) {
          return;
        }
        let inputPage = localForm.querySelector<HTMLInputElement>('input[name=currentPageId]');
        if (inputPage && inputCurrentPage) {
          inputPage.value = inputCurrentPage.value;
        }
        localForm.submit();
      }
    },
    addStoreEvent: function () {
      window.addEventListener('storage', this.handleStoreModified);
    },
    handleStoreModified: function (event: StorageEvent) {
      switch (event.key) {
        case 'MSG_FAVORITE_TOTAL':
          const totalFavorite = parseInt(event.newValue as string);
          let favoriteTotalEl = document.querySelector('.arjo-o-eshop-header-favorite-total');
          let favoriteParent = document.querySelector('.arjo-o-eshop-header-favorite');

          if (!favoriteParent) break;

          if (totalFavorite <= 0 || isNaN(totalFavorite)) {
            favoriteTotalEl?.remove();

            break;
          }

          if (!favoriteTotalEl) {
            favoriteTotalEl = document.createElement('span');
            favoriteTotalEl.classList.add('arjo-o-eshop-header-favorite-total');

            favoriteParent.appendChild(favoriteTotalEl);
          }

          favoriteTotalEl.textContent = `(${totalFavorite})`;
          break;
        case 'MSG_CART_TOTAL':
          const totalCart = event.newValue;
          let cartNumberEl = document.querySelector<HTMLElement>('.arjo-m-link-cart__content');

          if (!cartNumberEl) {
            return;
          }

          cartNumberEl.textContent = totalCart;
          break;
        default:
          break;
      }
    },
    /**
     * Init search bar menu
     */
    initSearchBarMenu: function () {
      const menus = document.querySelectorAll<HTMLAnchorElement>('.ajro-o-searchbar .arjo-a-link');

      if (!menus.length) {
        return;
      }

      menus.forEach((anchor: HTMLAnchorElement) => {
        const menuId = anchor?.dataset.menuId;

        if (!menuId) {
          return;
        }

        const menuItem = document.querySelector(`#${menuId}.has-children`);

        if (!menuItem) {
          return;
        }

        anchor.addEventListener('click', this.handleSearchBarMenuClick.bind(this));
      });
    },
    /**
     * Handle search bar menu click
     */
    handleSearchBarMenuClick: function (event: Event) {
      if (!arjoJs.isDesktop()) {
        return;
      }

      event.preventDefault();

      const $this = this;

      const currentAnchorElem = event.target as HTMLAnchorElement;
      const activeElem = document.querySelector<HTMLAnchorElement>('.ajro-o-searchbar .arjo-a-link.active');
      const menuId = currentAnchorElem?.dataset.menuId;
      const currentMenuItem = document.querySelector(`#${menuId}`);
      const arrowElem = currentMenuItem?.querySelector<HTMLElement>('.arjo-o-eshop-header-main-menu__arrow');
      const menuItemElem = document.querySelector<HTMLElement>('.arjo-o-eshop-header-main-menu__title');
      const menuItemElemAnchor = menuItemElem?.querySelector<HTMLAnchorElement>('a');

      // if click on the current element, header menu will be hidden
      if (currentAnchorElem?.classList.contains('active')) {
        $this.closeMainMenu();
        currentAnchorElem?.classList.remove('active');

        return;
      }

      // add class for anchor link
      activeElem && activeElem.classList.remove('active');
      currentAnchorElem.classList.add('active');

      if (menuItemElem && currentAnchorElem && menuItemElemAnchor) {
        menuItemElemAnchor.textContent = currentAnchorElem.textContent;
        menuItemElemAnchor.href = currentAnchorElem.href;
      }
      $this.openMainMenu();
      arrowElem?.dispatchEvent(new CustomEvent('click'));
    },

    /**
     * Set position for stick on anchor
     */
    initAnchorPosition: function () {
      let anchor = document.querySelector<HTMLElement>('.arjo-m-link-with-icon-list--anchor');

      if (!anchor) {
        return;
      }

      let clientRects = anchor.getBoundingClientRect();

      anchor.style.setProperty('--top', `${clientRects.top}px`);
    },
  };

  header.init();
})();

export { };
